<template>
  <b-card>
    <b-card-header>
      <b-row>
        <b-col sm="7">
          <h3 tabindex="0" style="padding-top: 25px;">Sistema Geral de Participações</h3>
        </b-col>
        <b-col sm="3">
          <img tabindex="0" src="/static/img/logo_governo_letra_escura.png" alt="MDHC" style="width: 80%; float: right;">
        </b-col>
        <b-col style="text-align: right;" sm="2" >
          <a tabindex="0" @click="navigate('/login')" @keyup.enter="navigate('/login')" @keyup.space="navigate('/login')" title="Entre aqui com seu gov.br" aria-label="Entre aqui com seu gov.br">
            <img src="/static/img/btGovbr.png" style="padding-top: 17px;width: 80%;" alt="Logo do gov.br"/>
          </a>
        </b-col>
      </b-row>
    </b-card-header>
    <b-card-body>
     <!-- <b-row class="mb-4">
        <b-col sm="12">
          <b-carousel :interval="10000" controls indicators>
            <b-carousel-slide img-src="https://picsum.photos/1024/480/?image=52"></b-carousel-slide>
            <b-carousel-slide img-src="https://mdbootstrap.com/img/Photos/Slides/img%20(15).jpg"></b-carousel-slide>
            <b-carousel-slide img-src="https://picsum.photos/1024/480/?image=58"></b-carousel-slide>
          </b-carousel>
        </b-col>
      </b-row>-->
      <b-row>
        <b-col sm="4">
          <b-form-group tabindex="0" label="Selecione a área da conferência:">
            <b-form-select v-model="filtro.area_id" @change="carregar()">
              <option :value="null" selected> Selecione </option>
              <option v-for="item in areas" :key="item.id" :value="item.id"> {{item.titulo}}</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- <b-row v-for="conferencia in conferencias" :key="conferencia.id">
        <b-col sm="12">
          <b-card tabindex="0" img-width="100%" img-top :img-src="endereco(conferencia)" img-left class="my-image">
            <b-card-body>
              <b-row>
                <b-col sm="10"><h5 tabindex="0">{{conferencia.nome}}</h5></b-col>
                <b-col>
                  <b-row align-h="end" v-if="conferencia.situacao === 'Inscrição Aberta'">
                    <b-button variant="success" @click="inscricao()">
                      <i class="fa fa-sign-in"></i>&nbsp;&nbsp;<span>Inscreva-se</span>
                    </b-button>
                  </b-row>
                </b-col>
              </b-row>
              <b-row><b-col>&nbsp;</b-col></b-row>
              <b-row>
                <b-col tabindex="0">{{conferencia.descricao}}</b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row> -->

      <b-row v-for="conferencia in conferencias" :key="conferencia.id">
        <b-col sm="12">
          <b-row>
            <b-col sm="12" md="4" lg="2" class="my-image order-1 order-md-1" style="padding-bottom: 5px;">
              <b-img  :src="endereco(conferencia)" fluid></b-img>
            </b-col>

            <b-col sm="12" md="8" lg="10" class="order-2 order-md-2">
              <b-card tabindex="0" >
                <b-card-body>
                  <b-row>
                    <b-col sm="10"><h5 tabindex="0">{{conferencia.nome}}</h5></b-col>
                    <b-col>
                      <b-row align-h="end" v-if="conferencia.situacao === 'Inscrição Aberta'">
                        <b-button variant="success" @click="inscricao()">
                          <i class="fa fa-sign-in"></i>&nbsp;&nbsp;<span>Inscreva-se</span>
                        </b-button>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row><b-col>&nbsp;</b-col></b-row>
                  <b-row>
                    <b-col tabindex="0">{{conferencia.descricao}}</b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
            
          </b-row>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<style scoped>
  @media screen and (max-width: 992px) {
    .my-image {
      height: 200px;
    }
  }
.my-image img {
  object-fit: contain;
  height: auto;
  width: 100%;
  margin-bottom: 5px;
  max-height: 200px;
}
</style>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  name: 'SiteTemplate',
  created () {
    this.$store.dispatch('getAreas')
  },
  data () {
    return {
      conferencias: [],
      filtro: {
        publica: true,
        area_id: null
      },
    }
  },
  computed: {
    ...mapState({
      areas: state => state.area.lista
    })
  },
  mounted () {
    this.carregar()
  },
  methods: {
    inscricao () {
      this.$router.push('/login')
    },
    navigate (route) {
      this.$router.push(route)
    },
    carregar () {
      Vue.http.post('api/configurarConferencia/buscar', this.filtro).then(response => {
        if (response.body.success) {
          this.conferencias = response.body.data
        }
      })
    },
    endereco (conferencia) {
      return process.env.ROOT_API1 + 'api/configurarConferencia/url/' + conferencia.id + '/' + conferencia.banner
    }
  }
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import 'flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import 'bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import '../../assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/templates/site-externo/SiteTemplate.vue